<template>
  <TextConfirm
    :loading="loading"
    :dialog="value"
    :title="$t('practitioner.appointments.cancel.title')"
    :text="$t('practitioner.appointments.cancel.text')"
    :confirmText="$t('general.dialog.cancelVisit')"
    :inputPlaceholder="`${$t('practitioner.appointments.cancel.reason')}*`"
    :cancelText="$t('general.dialog.noThanks')"
    @toggleDialog="toggleDialog"
    @confirm="cancelVisit"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { snackBarEventBus, snackBarEventName } from "@/eventBuses/snackBar.eventBus";

import TextConfirm from "../shared/TextConfirm";

export default {
  name: "CancelVisit",
  props: ["value", "appointmentId"],
  components: {
    TextConfirm,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters("videoRoom", ["encounter"]),
  },
  methods: {
    ...mapActions("appointments", ["cancelAppointment"]),
    ...mapActions("videoRoom", ["getRoomStatus"]),
    toggleDialog() {
      this.$emit("input", !this.value);
    },
    async cancelVisit(text) {
      this.$gtag.event("click", { method: "Cancel Visit" });
      this.loading = true;
      try {
        if (this.appointmentId) {
          await this.cancelAppointment({
            id: this.appointmentId,
            cancellationReason: text,
          });
        } else {
          await this.cancelAppointment({
            id: this.encounter.appointmentId,
            cancellationReason: text,
          });
          await this.getRoomStatus();
        }
        snackBarEventBus.$emit(snackBarEventName, {
          message: this.$t("practitioner.appointments.cancel.success"),
          type: "success",
        });
        this.toggleDialog();
        this.$emit("success");
      } catch (e) {
        snackBarEventBus.$emit(snackBarEventName, { message: e.message || e, type: "error" });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
